// extracted by mini-css-extract-plugin
export default {"componentCalendarMenu":"CalendarDatasourceMenu-module_componentCalendarMenu_obs3E","active":"CalendarDatasourceMenu-module_active_oWPjY"};